import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Types
import { QuickStartGuideItemIDs } from '../QuickStartGuideItems.constants';

// Hooks
import useUpdateQuickStartGuideFlag from '../useUpdateQuickStartGuideFlag';

// Utils
import { trackClickQuickStartGuideCTA } from 'Shared/tracking/tracking';

// Components
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';

import { useTranslation } from 'Shared/contexts/TranslationsContext';

// Styles
import './UpdateYourProfileStep.scss';

type Props = {
  navigateToList: Function;
};

const UpdateYourProfileStep = ({ navigateToList }: Props) => {
  const step = QuickStartGuideItemIDs.updateYourProfile;
  const history = useHistory();
  const { handleSkipItem, hasBeenSet } = useUpdateQuickStartGuideFlag();
  const [isSet] = useState(hasBeenSet(step));

  const { tr } = useTranslation();

  const handleClick = () => {
    trackClickQuickStartGuideCTA(step);
    history.push(PageUrlsConstants.CURRENT_USER_PROFILE_PAGE);
  };

  const handleSkipClick = () => {
    handleSkipItem(step);
    navigateToList();
  };

  useEffect(() => {
    if (!isSet && hasBeenSet(step)) navigateToList();
  }, [isSet, hasBeenSet]);

  const baseClassName = 'UpdateYourProfileStep';
  return (
    <>
      <div className={baseClassName}>
        <div className={`${baseClassName}__button`}>
          <WpButtonGroup stacked>
            <WpButton size="lg" onClick={handleClick}>
              {tr('perform.onboarding.qsg.update_profile.go_to_profile')}
            </WpButton>
            {!isSet && (
              <WpButton size="lg" onClick={handleSkipClick} variant="tertiary">
                {tr('perform.onboarding.qsg.common.skip')}
              </WpButton>
            )}
          </WpButtonGroup>
        </div>
        <WpIllustration
          className={`${baseClassName}__image`}
          src={Illustrations.person_working_at_desk_alone_with_purple_bg}
        />
      </div>
    </>
  );
};
export default UpdateYourProfileStep;
